const svc = 
	process.env.NONE_ENV !== 'production'
		? require('./prod').default
		: require('./prod').default;

export default { ...svc };
